
function authHeader() {
  return { 'x-api-key': 'rtynujrt76y7umr567r6hbcfthndtygh' };
}

export default authHeader;
